import {reducer} from './helpers'

import {
  OPEN_VENDOR_APPLICATION,
  CLOSE_VENDOR_APPLICATION,
  SHOW_VENDOR_ADDRESS_FORM,
  SET_VENDOR_ID,
} from '../actions/blackDesk'

const initialState = {
  vendorApplicationIsOpen: false,
  currentVendorForm: 'vendor',
  vendorId: undefined,
}

export default reducer(initialState, (state, action) => {
  switch (action.type) {
    case CLOSE_VENDOR_APPLICATION:
      return {
        vendorApplicationIsOpen: false,
      }
    case OPEN_VENDOR_APPLICATION:
      return {
        vendorApplicationIsOpen: true,
      }
    case SHOW_VENDOR_ADDRESS_FORM:
      return {
        currentVendorForm: 'address',
      }
    case SET_VENDOR_ID:
      return {
        vendorId: action.payload,
      }
    default:
      return null
  }
})
